<div class="accordion-container" [adsptAnimateHeight]="expanded" (@autoHeight.done)="animationDone(div)" #div>
    <ng-container *ngTemplateOutlet="header?.tr"></ng-container>

    <ng-container *ngTemplateOutlet="expanded ? expandedContent?.tr : collapsedContent?.tr"></ng-container>
</div>
